<template>
  <div class="section_popup">
    <!-- 多个直播列表-->
    <div class="live_course_box">
      <img class="icon_live" src="@/assets/img/loginImg/icon_live.png" alt="" />
      <h1>当前课程有以下直播正在进行中</h1>
      <div class="live_course_content">
        <img class="table_close" src="@/assets/img/loginImg/tabClose.png" @click="close" alt />
        <div class="live_course_list">
          <ul>
            <li v-for="(item, index) in videoList" :key="index">
              <span class="video_title">{{ item.name }}</span>
              <div class="bottom">
                <span class="time">{{ getTime(item.startTime) }}-{{ getTime(item.endTime) }}</span>
                <div class="flex_center" @click="goLive(item)">
                  <span>进入直播</span>
                  <img src="@/assets/img/loginImg/centerRight.png" alt />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="shadow"></div>
    </div>
  </div>
</template>
<script>
import { dateTime, replaceHyphens } from '../../utils/tools';

export default {
  components: {},
  data() {
    return {};
  },
  props: {
    videoList: {
      type: Array,
      default: () => [],
    },
    openCourseId: {
      type: Number,
      default: () => 0,
    },
    gioEnter: {
      type: String,
      default: ''
    },
  },
  watch: {},
  created() {},
  mounted() {
    console.log(this.gioEnter)
  },
  destroyed() {},
  methods: {
    // 时间转换
    getTime(time) {
      const showTime = dateTime(new Date(replaceHyphens(time)).getTime());
      return `${showTime.h}:${showTime.m}`;
    },
    // 关闭弹窗
    close() {
      this.$emit('closeLive');
    },
    // 进入直播间
    goLive(item) {
      // 进入直播
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'goLiveRoomPage',
          {
            openCourseRecordId: this.openCourseId,
            roomId: item.roomId,
            liveName: item.name, // 直播名称
            productId: item.courseId, // 产品id
            liveId: item.id, // 直播id
            chapterId: item.curriculumNodeId, // 章节id
            productName: '',
            gioEnter:this.gioEnter
          },
          false,
        );
        return;
      }
      // return;
      const { liveSource } = item?.liveBaseInfoRespVO ? item.liveBaseInfoRespVO : item;
      // 百家云直播
      if (liveSource === 2) {
        this.$router.push({
          path: '/liveBJY',
          query: {
            roomId: item.roomId,
            courseId: item.courseId,
            liveId: item.id,
            chapterId: item.curriculumNodeId,
            liveName: item.name,
            templateType: item.templateType,
            gioEnter:this.gioEnter
          },
        });
        return;
      }
      // CC 区分是三分屏 或者大视频
      const path =
        item.templateType === 4 || item.templateType === 5 ? '/threeScreenLive' : '/live';
      this.$router.push({
        path,
        query: {
          roomId: item.roomId,
          courseId: item.courseId,
          liveId: item.id,
          chapterId: item.curriculumNodeId,
          liveName: item.name,
          gioEnter:this.gioEnter
        },
      });
      this.$emit('closeLive');
    },
  },
};
</script>

<style lang="scss" scoped>
.section_popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9900;
  background-color: rgba(0, 0, 0, 0.2);
}
.table_close {
  width: 29px;
  height: 29px;
  cursor: pointer;
}

// 多个直播弹窗
.live_course_box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 678px;
  height: 558px;
  padding-top: 80px;
  background: #fff;
  border-radius: 14px;
  // box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.08);
  transform: translate(-50%, -50%);
  h1 {
    width: 100%;
    height: 45px;
    margin-bottom: 29px;
    color: #333;
    font-weight: 500;
    font-size: 33px;
    line-height: 45px;
    text-align: center;
  }
  .table_close {
    position: absolute;
    top: 36px;
    right: 36px;
    width: 29px;
    height: 29px;
    color: #666;
  }
  .icon_live {
    position: absolute;
    top: -45px;
    right: 0;
    left: 0;
    display: block;
    width: 114px;
    height: 114px;
    margin: 0 auto;
  }
  .live_course_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    height: 346px;
    overflow: auto;
    .live_course_title {
      padding-top: 50px;
      padding-bottom: 24px;
      i {
        display: inline-block;
        width: 35px;
        height: 1px;
        background: rgba(#979797, 0.2);
      }
      span {
        padding: 0 20px;
        color: #333;
        font-size: 18px;
      }
    }
    .live_course_list {
      width: 100%;
      height: 100%;
      padding: 0 29px;
      ul {
        width: 100%;
        height: 100%;
        // padding-bottom: 40px;
        li {
          display: flex;
          flex-direction: column;
          width: 620px;
          height: 125px;
          margin-bottom: 22px;
          padding: 22px;
          background: #fff8f2;
          border-radius: 7px;
          .icon_live_video {
            width: 49px;
          }
          .bottom {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            .time {
              height: 31px;
              color: #787878;
              font-weight: 400;
              font-size: 22px;
              line-height: 31px;
            }
            .flex_center {
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-top: 18px;
              img {
                width: 32px;
                height: 32px;
              }
              span {
                color: #ff6c02;
                font-size: 24px;
              }
            }
          }
          .video_title {
            width: 580px;
            height: 36px;
            color: #333;
            font-weight: 500;
            font-size: 25px;
            line-height: 36px;
            @extend .ellipsis;
          }
        }
        // li:last-child{
        //   margin-bottom: 40px;
        // }
      }
    }
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: rgba(125, 125, 125, 0.3);
  -webkit-border-radius: 6px;
}

::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  background-color: rgba(125, 125, 125, 0.3);
  -webkit-border-radius: 6px;
}
.shadow {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 85px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
  border-radius: 0 0 14px 14px;
}
</style>
